import { useEffect, useState } from "react";
import api from "../api";
import { setClockTimeSeparatorMode } from "../utils/answerMatchUtils";

/**
 * Is the Practice toggle available at all?
 *
 * Admin → Settings → Student can hide it. Practice mode is what unlocks Check answer, so when the
 * toggle is hidden the Check answer buttons go with it — leaving them would let a student who was
 * already in practice mode keep grading answers with no way to switch back.
 *
 * Cached per page load: five surfaces ask for this (both layouts and the three take pages) and the
 * answer cannot change without a reload.
 */
let cached = null;

const endpointForRole = () => {
  const role = (localStorage.getItem("role") || "").toLowerCase().trim();
  return role === "parent" ? "parent/settings" : "student/settings";
};

export const fetchPracticeModeVisible = () => {
  if (!cached) {
    cached = api
      .get(endpointForRole())
      .then((res) => {
        // The same response carries how a clock time may be written ("5:52" / "5.52"), which the
        // client matchers must apply exactly as the server grader does.
        setClockTimeSeparatorMode(res.data?.data?.clock_time_separator);
        // Absent means an older backend that has no such setting — the toggle stays visible.
        return res.data?.data?.show_practice_mode !== false;
      })
      .catch(() => true);
  }
  return cached;
};

const usePracticeModeVisible = () => {
  // Start hidden-free: assume visible so the toggle does not flicker out for the common case.
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchPracticeModeVisible().then((v) => {
      if (!cancelled) setVisible(v);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return visible;
};

export default usePracticeModeVisible;
